import { apiClient } from 'pobble-components/dist/api'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import injectSheet from 'react-jss'
import { Image } from 'pobble-components/dist/image'
import Button from 'pobble-components/dist/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-regular-svg-icons/faPencil'
import { faShare } from '@fortawesome/pro-regular-svg-icons/faShare'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { Link, useHistory, useParams } from 'react-router-dom'
import { Presentation } from 'pobble-components/dist/presentation'
import PrintModal from '../../print-modal/print-modal'
import ButtonElement from 'pobble-components/dist/button-element'
import { toast } from 'pobble-components/dist/toast'
import { useMemo } from 'react'
import {
  daysOfWeek,
  getWeekday,
  months,
  YEAR
} from './calendar/calendar.helpers'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'
import builder from './builder.jpg'
import { UpsellModal } from './upsell'
import { PromptsLayout } from '../../prompts-layout'
import { ShareModal } from '../../share/share'
import { faUsersClass } from '@fortawesome/pro-regular-svg-icons/faUsersClass'
import { SlidesDeck } from '../../slides-deck/slides-deck'
import classNames from 'classnames'
import { RateLessonCTA } from './rating'
import useFreePrompts from '../../../common/utils'
import posthog from 'posthog-js'
import { useMe } from 'pobble-components/dist/pobble-user'
import wiggleBorder from './wiggle-border.png'
import daisyLogo from './sponsors/daisy-logo.png'
import sumdogLogo from './sponsors/sumdog-logo.png'
import { useDifficultyLevels } from './differentiation'
import PresentationControls from '../../presentation-controls/presentation-controls'
import { SubsCrown } from 'pobble-components/dist/subscriptions'
import { usePresentMode } from '../../pages/direct-present/present-mode'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getErrorInfo } from 'pobble-components/dist/utils'
import { SaveForLaterBanner } from './save-for-later-banner'

const DEFAULT_INCLUDE =
  'presentation.audio,presentation.p365,presentation.account,presentation.category,presentation.status,presentation.image,presentation.year_groups,presentation.details,presentation.slides,presentation.slide.type,presentation.slide.details,presentation.names'

const EditUpsell = props => {
  return (
    <UpsellModal
      id="edit"
      ctaLink="/account/membership?from=edit#tiers-individuals"
      ctaClassName="metrics__subscription_modal--edit"
      {...props}>
      <h2>Get access to the Pobble Builder</h2>
      <img
        width="1207"
        height="704"
        src={builder}
        alt="Entire calendar unlocked"
      />
      <p>
        Use the Pobble Builder to edit existing activites or add new activities
        such as <strong>work exemplar</strong>, <strong>word bank</strong> or{' '}
        <strong>grammar exercise</strong>.
      </p>
    </UpsellModal>
  )
}

const SvgScrollArrow = props => (
  <svg {...props} viewBox="0 0 1792 1792">
    <path d="M1675 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37L155 922q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294V256q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z" />
  </svg>
)

const SVGLeftArrow = props => (
  <svg viewBox="0 0 1792 1792" {...props}>
    <path d="M1203 544q0 13-10 23L800 960l393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10L631 983q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z" />
  </svg>
)

const SVGRightArrow = props => (
  <svg viewBox="0 0 1792 1792" {...props}>
    <path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z" />
  </svg>
)

const HeroHeader = injectSheet({
  heroHeader: {
    position: 'sticky',
    display: 'flex',
    top: '0',
    zIndex: '40',
    width: '100%',
    opacity: '0',
    pointerEvents: 'none',
    background:
      'linear-gradient(to bottom, rgba(25, 25, 25, .8), rgba(25, 25, 25, .6), rgba(25, 25, 25, .4), rgba(25, 25, 25, 0))',
    '@media (min-width: 768px)': {
      height: '80px'
    }
  },
  scrolledPastHero: {
    background: '#191919',
    opacity: '1',
    pointerEvents: 'auto',
    boxShadow: '0 3px 5px rgb(0 0 0 / 50%)'
  }
})(({ children, classes }) => {
  const [scrolledPastHero, setScrolledPastHero] = useState(false)

  useEffect(
    () => {
      const listener = () => {
        if (window.pageYOffset - window.innerHeight > 200) {
          if (!scrolledPastHero) setScrolledPastHero(true)
        } else {
          if (scrolledPastHero) {
            setScrolledPastHero(false)
          }
        }
      }
      window.addEventListener('scroll', listener)
      return () => {
        window.removeEventListener('scroll', listener)
      }
    },
    [scrolledPastHero]
  )

  return (
    <header
      className={`${classes.heroHeader} ${scrolledPastHero &&
        classes.scrolledPastHero}`}>
      {children({ scrolledPastHero })}
    </header>
  )
})

const Nav = injectSheet({
  button: {
    position: 'absolute',
    top: 'calc(50vh - 80px)',
    left: '0',
    zIndex: '20',
    opacity: '0',
    transform: 'translateX(8px)',
    animation: '.5s appear .2s ease-out forwards',
    '& svg': {
      width: '72px',
      height: '80px',
      fill: 'rgba(255, 255, 255, .6)',
      stroke: '#000',
      strokeWidth: '4px',
      strokeOpacity: '.5'
    },
    '&:hover': {
      '& svg': {
        fill: 'rgba(255, 255, 255, 1)'
      },
      '& img': {
        opacity: 1
      }
    }
  },
  buttonNext: {
    left: 'auto',
    right: '0',
    transform: 'translateX(-8px)'
  },
  '@keyframes appear': {
    to: {
      transform: 'translateY(0)',
      opacity: '1'
    }
  },
  adjacentThumbWrapper: {
    position: 'relative',
    opacity: 0,
    transition: '400ms ease-out opacity 200ms',
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    },
    '& span': {
      position: 'absolute',
      color: '#333',
      fontWeight: 'bold',
      zIndex: '10',
      opacity: '0.8',
      bottom: '10px',
      left: '6px',
      fontSize: '9px',
      background: '#fff',
      borderRadius: '2px',
      textTransform: 'uppercase',
      padding: '0px 4px'
    }
  },
  adjacentThumb: {
    display: 'inline-block',
    border: '2px solid #fff',
    borderRadius: '8px',
    opacity: '0.7',
    position: 'relative',
    width: '120px',
    height: '69px'
  },
  adjacentNextLabel: {
    right: '6px',
    left: 'auto !important'
  },
  thumbLoaded: {
    opacity: '1'
  }
})(({ classes, className, presentation }) => {
  const [adjacentPresentations, setAdjacentPresentations] = useState(null)

  const history = useHistory()

  useEffect(
    () => {
      setAdjacentPresentations(null)
      if (presentation) {
        apiClient
          .get(`/v3/p365/${presentation.id}`, {
            params: {
              count: 3,
              from: 0,
              include: 'presentation.image'
            }
          })
          .then(res =>
            setAdjacentPresentations({
              prev: res.data.presentations[0].id,
              next: res.data.presentations[2].id,
              prevThumb:
                res.data.presentations[0].image &&
                res.data.presentations[0].image.thumb_url,
              nextThumb:
                res.data.presentations[0].image &&
                res.data.presentations[2].image.thumb_url
            })
          )
          .catch(e => undefined)
      }
    },
    [presentation]
  )

  const [loaded, setLoaded] = useState(false)

  return !presentation || !presentation.p365 ? null : (
    <>
      <ButtonElement
        onClick={() => {
          apiClient.post('/v3/me/activated_with_product', {
            type: 'content'
          })
          posthog.capture('activate', { type: 'content' })
          posthog.capture('click on navigation button on prompt', {
            direction: 'prev'
          })
          adjacentPresentations &&
            history.push(`/prompt/${adjacentPresentations.prev}`)
        }}
        className={`${classes.button} ${
          classes.buttonPrev
        } metrics__prompt_prev`}>
        <SVGLeftArrow />
        {adjacentPresentations && (
          <div
            className={`${classes.adjacentThumbWrapper} ${className} ${
              loaded ? classes.thumbLoaded : ''
            }`}>
            <span>Yesterday</span>
            <Image
              className={`${classes.adjacentThumb}`}
              src={adjacentPresentations.prevThumb}
              alt={"Yesterday's lesson"}
              onLoad={() => setLoaded(true)}
            />
          </div>
        )}
      </ButtonElement>
      <ButtonElement
        onClick={() => {
          apiClient.post('/v3/me/activated_with_product', {
            type: 'content'
          })
          posthog.capture('activate', { type: 'content' })
          posthog.capture('click on navigation button on prompt', {
            direction: 'next'
          })
          adjacentPresentations &&
            history.push(`/prompt/${adjacentPresentations.next}`)
        }}
        className={`${classes.button} ${
          classes.buttonNext
        } metrics__prompt_prev`}>
        {adjacentPresentations && (
          <div
            className={`${classes.adjacentThumbWrapper} ${className} ${
              loaded ? classes.thumbLoaded : ''
            }`}>
            <span className={classes.adjacentNextLabel}>Tomorrow</span>
            <Image
              className={`${classes.adjacentThumb} ${
                classes.adjacentThumbNext
              }`}
              src={adjacentPresentations.nextThumb}
              alt={"Tomorrow's lesson"}
              onLoad={() => setLoaded(true)}
            />
          </div>
        )}
        <SVGRightArrow />
      </ButtonElement>
    </>
  )
})

const Actions = injectSheet({
  caret: {
    margin: '0 -2px 0 4px'
  },
  dropMenu: {
    color: 'var(--gray)'
  },
  main: {
    background: 'var(--yellow)',
    color: 'var(--gray)',
    '&:hover': {
      background: 'var(--yellow)',
      color: '#000'
    }
  },
  secondary: {
    color: 'var(--light-gray) !important',
    background: 'rgb(0 0 0 / 40%) !important',
    '&:hover': {
      background: 'rgb(0 0 0 / 50%) !important'
    }
  },
  crown: {
    fontSize: '10px',
    color: 'var(--yellow)'
  },
  crownBlack: {
    fontSize: '10px',
    color: 'var(--gray)'
  },
  saved: {
    color: 'var(--light-gray) !important',
    '& a': {
      color: 'var(--light-gray)',
      pointerEvents: 'auto'
    }
  },
  container: {
    display: 'flex',
    gap: '16px',
    marginLeft: 'auto',
    '& button': {
      border: 'none',
      boxShadow: 'none',
      '@media (min-width: 768px)': {
        width: 'auto'
      }
    }
  }
})(({ presentation, classes, onSaved }) => {
  const [printModalOpen, setPrintModalOpen] = useState(false)
  const [savedStatus, setSavedStatus] = useState(null)
  const [showShareModal, setShowShareModal] = useState(false)
  const [upsellModalOpen, setUpsellModalOpen] = useState(false)

  const history = useHistory()

  const saveLesson = (
    <>
      {savedStatus !== 'saved' && (
        <Button
          minw
          pending={savedStatus === 'pending'}
          action={() => {
            apiClient.post('/v3/me/activated_with_product', {
              type: 'feature'
            })
            posthog.capture('activate', { type: 'feature' })
            posthog.capture('click on add to my lesson', {
              from: 'prompt header'
            })

            setSavedStatus('pending')
            apiClient
              .post(
                `/v3/presentations/${presentation.id}/create_presentation_copy`
              )
              .then(res => {
                history.push(`/lesson/${res.data.presentation.id}`, {
                  fromPrompt: true
                })
              })
          }}
          className={`${classes.secondary} metrics__save`}
          tall
          icon={<FontAwesomeIcon icon={faPencil} />}>
          {'Edit lesson'}
        </Button>
      )}

      {savedStatus === 'saved' && (
        <Button
          className={classes.saved}
          minw
          simple
          white
          disabled
          tall
          icon={<FontAwesomeIcon icon={faCheck} />}>
          <>
            Copied to&nbsp;<Link to="/">"My lessons"</Link>
          </>
        </Button>
      )}
    </>
  )

  const shareLesson = (
    <Button
      minw
      action={() => {
        apiClient.post('/v3/me/activated_with_product', {
          type: 'feature'
        })
        posthog.capture('activate', { type: 'feature' })
        posthog.capture('click on share from prompt')
        setShowShareModal(true)
      }}
      className={`${classes.secondary} metrics__share_from_prompt`}
      tall
      icon={<FontAwesomeIcon icon={faShare} />}>
      Share
    </Button>
  )

  const { present } = usePresentMode()
  const { me } = useMe()
  const { hasAccessToTL } = useSubscriptionDetails()

  const posthogActionData = {
    id: presentation.id,
    title: presentation.title,
    category: presentation.category,
    from: 'prompt',
    hasAccessToTL,
    role: me.account.role_in_life
  }

  const fullScreenButton = (
    <Button
      minw
      action={() => {
        apiClient.post('/v3/me/activated_with_product', {
          type: 'feature'
        })
        posthog.capture('activate', { type: 'feature' })
        posthog.capture('Share action', {
          action: 'Full screen',
          ...posthogActionData
        })
        apiClient.post(
          `/v3/presentations/${presentation.id}/presented_fullscreen`
        )
        present(presentation.id)
      }}
      className={`${classes.secondary}`}
      tall
      icon={<FontAwesomeIcon icon={faUsersClass} />}>
      {'Present'}
    </Button>
  )

  return !presentation ? null : (
    <div className={classes.container}>
      <PresentationControls
        presentation={presentation}
        style={{ color: '#fff' }}
      />
      {saveLesson}
      {shareLesson}
      {fullScreenButton}
      {presentation && (
        <>
          <PrintModal
            id={presentation.id}
            isOpen={printModalOpen}
            requestClose={() => setPrintModalOpen(false)}
          />
          {presentation && (
            <ShareModal
              from="prompt"
              presentation={presentation}
              isOpen={showShareModal}
              requestClose={() => setShowShareModal(false)}
            />
          )}
        </>
      )}
      <UpsellModal
        id={upsellModalOpen}
        isOpen={!!upsellModalOpen}
        requestClose={() => setUpsellModalOpen(false)}
      />
    </div>
  )
})

export const Prompt = injectSheet({
  container: {
    background: '#191919',
    position: 'relative'
  },
  heroSection: {
    position: 'relative',
    marginTop: '-140px',
    '@media (min-width: 768px)': {
      marginTop: '-80px'
    },
    '@media (max-width: 1023px)': {
      height: 'calc(100vh - 140px) !important'
    },
    '@supports (-webkit-touch-callout: none)': {
      height: 'calc(100vh - 220px) !important'
    }
  },
  heroImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  heroFooter: {
    color: '#fff',
    position: 'absolute',
    bottom: '0',
    width: '100%',
    background:
      'linear-gradient(to top, rgba(25, 25, 25, 1), rgba(0, 0, 0, 0))',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px'
  },
  scroll: {
    backgroundColor: 'rgba(255, 255, 255, .1)',
    border: '2px solid rgba(255, 255, 255, .5)',
    borderRadius: '16px',
    height: '52px',
    width: '32px',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '24px',
    opacity: '0',
    transform: 'translateY(-4px)',
    animation: '.3s appear .2s ease-out forwards',
    '& svg': {
      fill: 'rgba(255, 255, 255, .5)',
      width: '14px',
      height: '14px',
      animation: 'scroll 3.9s infinite'
    },
    '&:hover': {
      borderColor: '#fff',
      '& svg': {
        fill: '#fff'
      }
    }
  },
  title: {
    margin: '0 0 16px',
    textAlign: 'center',
    font: 'var(--heading_)',
    opacity: '0',
    transform: 'translateY(8px)',
    animation: 'appear .3s ease-out forwards'
  },
  play: {
    opacity: 0,
    transform: 'translateY(8px)',
    animation: '.3s appear .2s ease-out forwards',
    marginBottom: '16px'
  },
  snippet: {
    margin: '-4px 0 16px',
    textAlign: 'center',
    color: 'var(--light-gray)',
    opacity: '0',
    font: 'var(--body)',
    transform: 'translateY(8px)',
    animation: '.3s appear .2s ease-out forwards'
  },
  activities: {
    padding: '0 20px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    '@media (min-width: 1024px)': {
      padding: '0 56px 56px'
    }
  },
  activitiesHeader: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: '8px 0 56px',
    gap: '24px',
    textAlign: 'center',
    color: '#fff',
    '& img': {
      margin: '32px 0',
      width: '260px',
      objectFit: 'cover',
      objectPosition: 'center'
    },
    '& h3': {
      margin: '0',
      font: 'var(--heading-)'
    }
  },
  slide: {
    marginBottom: '32px',
    position: 'relative',
    '@media (min-width: 1024px)': {
      marginBottom: '64px'
    }
  },
  slideRestricted: {
    opacity: '0.5',
    filter: 'blur(5px)',
    userSelect: 'none',
    '& > *': {
      pointerEvents: 'none'
    }
  },
  slideRestrictedCTA: {
    top: '50%',
    position: 'absolute',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    maxWidth: '60%',
    minHeight: '60px'
  },
  slideHolder: {
    borderRadius: '8px',
    overflow: 'hidden'
  },
  editButton: {
    color: '#fff !important',
    font: 'var(--heading--)',
    marginBottom: '4px',
    '& > div': {
      height: '14px'
    }
  },
  main: {
    background: '#fff',
    color: 'var(--gray)',
    '&:hover': {
      background: '#fff',
      color: '#000'
    }
  },
  secondary: {
    background: 'none',
    color: 'var(--light-gray)',
    border: '1px solid var(--light-gray) !important',
    '&:hover': {
      background: 'none',
      color: 'var(--light-gray)'
    }
  },
  accentButton: {
    background: 'var(--yellow)',
    color: 'var(--gray)',
    '&:hover': {
      background: 'var(--yellow)',
      color: '#000'
    }
  },
  simpleButton: {
    background: 'none !important',
    color: 'rgba(255, 255, 255, .9)',
    border: 'none'
  },
  resources: {
    paddingRight: '0',
    '@media (min-width: 768px)': {
      paddingRight: '15px'
    }
  },
  explore: {
    display: 'flex',
    alignItems: 'center !important',
    font: 'var(--body-)',
    marginLeft: 'auto'
  },
  tagLine: {
    color: '#fff',
    marginRight: '4px',
    display: 'none',
    '@media (min-width: 769px)': {
      display: 'block'
    }
  },
  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateY(-4px)',
    animation: '.5s appear .4s forwards',
    opacity: '0',
    '& button': {
      margin: '0 0 16px !important'
    },
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      '& button': {
        margin: '0 16px 0 0 !important'
      }
    }
  },
  myPrompt: {
    background: 'none !important',
    color: '#fff',
    border: 'none',
    padding: '12px 15px',
    fontWeight: 'bold',
    marginLeft: '8px',
    '& svg': {
      marginRight: '6px',
      fontSize: '.8em'
    },
    '& a': {
      textDecoration: 'underline',
      color: '#fff'
    }
  },
  info: {
    margin: '8px 0',
    font: 'var(--body)',
    opacity: '0',
    transform: 'translateY(8px)',
    animation: '.3s appear .1s ease-out forwards',
    color: 'var(--yellow)',
    fontWeight: 'bold'
  },
  builder: {
    width: '100%',
    padding: '2% 10% 8%',
    background: 'rgba(255, 255, 255, .2)',
    borderRadius: '8px',
    border: '2px solid transparent',
    '& > *': {
      pointerEvents: 'none'
    },
    '&:hover': {
      borderColor: 'var(--blue)'
    },
    '&:focus': {
      borderColor: '#fff'
    },
    '&:active': {
      borderColor: '#fff'
    },
    '& img': {
      display: 'block',
      maxWidth: '100%'
    },
    '& > span': {
      fontSize: '24px',
      lineHeight: '1.2',
      display: 'block',
      textAlign: 'center',
      color: '#fff',
      fontWeight: 'bold',
      '@media (min-width: 768px)': {
        fontSize: '56px'
      }
    }
  },
  yellow: {
    color: 'var(--yellow)'
  },
  calendarButton: {
    '& span': {
      display: 'none',
      '@media (min-width: 1024px)': {
        display: 'inline'
      }
    }
  },
  headerHolder: {
    display: 'flex',
    width: '100%',
    maxWidth: '1200px',
    padding: '20px 20px',
    margin: '0 auto',
    '@media (min-width: 1024px)': {
      padding: '20px 56px'
    }
  },
  headerDifficulty: {
    display: 'none',
    '@media (min-width: 768px)': {
      display: 'block'
    }
  },
  actionsHolder: {
    marginLeft: 'auto'
  },
  separator: {
    width: '1px',
    height: '16px',
    background: '#fff',
    display: 'none',
    '@media (min-width: 1024px)': {
      display: 'block'
    }
  },
  saved: {
    animation: 'fadeFromYellow 1s ease-out'
  },
  restrictedFooter: {
    background:
      'linear-gradient(to top, rgba(25, 25, 25, 1), rgba(25, 25, 25, 1), rgba(0, 0, 0, 0))'
  },
  restricted: {
    marginTop: '16px',
    paddingTop: '24px',
    padding: '8px 0',
    font: 'var(--body)',
    fontWeight: 'bold',
    '& p': {
      margin: '0'
    },
    '@media (min-width: 768px)': {
      borderTop: '1px solid rgba(255, 255, 255, .3)'
    }
  },
  restrictedPadding: {
    height: '20px'
  },
  restrictedHolder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    opacity: '0',
    transform: 'translateY(-4px)',
    animation: '.6s appear .3s ease-out forwards',
    textAlign: 'center',
    maxWidth: '230px',
    '@media (min-width: 768px)': {
      maxWidth: 'none'
    }
  },
  restrictedDate: {
    color: 'var(--yellow)'
  },
  restrictedActivitiesMessage: {
    font: 'var(--body--)',
    fontWeight: 'normal',
    margin: '32px 0 16px !important',
    textAlign: 'center'
  },
  mainDiffSelector: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '8px',
    '& p': {
      font: 'var(--body-)'
    }
  },
  fixedHeader: {
    position: 'absolute',
    height: '80px',
    padding: '20px',
    zIndex: '10',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    background:
      'linear-gradient(to bottom, rgba(25, 25, 25, 1), rgba(25, 25, 25, 0))',
    '& > div': {
      opacity: '0',
      transform: 'translateY(4px)',
      animation: '.3s appear .5s ease-out forwards'
    }
  },
  panelCTATest: {
    background: 'var(--yellow)',
    color: '#000',
    '&:hover': {
      background: 'var(--yellow-)',
      color: '#000'
    }
  },
  middleCTA: {
    '& > *': {
      border: 'none'
    }
  },
  ftPromptCTA: {
    color: '#fff !important',
    fontSize: '16px',
    border: '1px solid #fff',
    marginBottom: '30px'
  },
  emailMeCTA: {
    fontSize: '18px',
    padding: '24px 30px',
    background: 'var(--yellow)',
    color: '#333 !important',
    '&:hover': {
      background: 'var(--yellow-)',
      color: '#333'
    }
  },
  sponsoredLogo: {
    background: '#fff',
    outline: '4px solid #fff',
    marginTop: '8px'
  },
  '@keyframes appear': {
    to: {
      transform: 'translateY(0)',
      opacity: '1'
    }
  },
  '@keyframes fadeFromYellow': {
    from: {
      background: 'rgba(254, 228, 51, 1)'
    },
    to: {
      background: 'rgba(254, 228, 51, 0)'
    }
  },
  '@keyframes scroll': {
    '0%': {
      transform: 'translateY(-12px)',
      opacity: 0
    },
    '20%': {
      transform: 'translateY(8px)',
      opacity: 1
    },
    '80%': {
      transform: 'translateY(8px)',
      opacity: 1
    },
    '85%': {
      opacity: 1
    },
    '97%': {
      opacity: 0
    },
    to: {
      transform: 'translateY(44px)',
      opacity: 0
    }
  }
})(({ classes }) => {
  const [presentation, setPresentation] = useState(null)
  const [todayPresentationId, setTodayPresentationId] = useState(null)
  const slidesContainerRef = useRef(null)
  const { id } = useParams()
  const [editUpsellOpen, setEditUpsellOpen] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const freePromptIds = useFreePrompts()

  const {
    difficultySelector,
    selectedPresentation,
    isDifferentiated
  } = useDifficultyLevels({
    presentation,
    includeString: DEFAULT_INCLUDE
  })

  const allDataLoaded = !!presentation && !!freePromptIds

  const { hasAccessToTL } = useSubscriptionDetails()
  const { me } = useMe()

  const studentWithoutSub =
    me.account.role_in_life === 'student' && !hasAccessToTL

  const restrictedPrompt =
    presentation &&
    !presentation.sponsored &&
    !hasAccessToTL &&
    !!freePromptIds &&
    !freePromptIds.has(presentation.id)

  const [yearGroups, setYearGroups] = useState(null)

  const date = useMemo(
    () => {
      if (presentation) {
        if (presentation.p365_month && presentation.p365_day) {
          const monthIndex = presentation.p365_month - 1
          const dateString = `${YEAR}-${presentation.p365_month}-${
            presentation.p365_day
          }`

          const weekdayIndex = (getWeekday(dateString) + 6) % 7

          return `${daysOfWeek[weekdayIndex]}, ${months[monthIndex]} ${
            presentation.p365_day
          }`
        }
      }
    },
    [presentation]
  )

  /**
   * Fetch yearGroups
   */
  useEffect(() => {
    apiClient
      .get('v3/year_groups', {
        params: {
          include: 'include=year_group.names,year_group.order'
        }
      })
      .then(res => {
        setYearGroups(res.data.year_groups)
      })
  }, [])

  const yearGroup = useMemo(
    () => {
      if (!yearGroups || !presentation) return null
      return yearGroups.filter(
        yg => yg.id === presentation.year_groups[0].id
      )[0]
    },
    [yearGroups, presentation]
  )

  /**
   * Show a toast message for users who got redirected
   *  after buying a subscription
   */
  useEffect(
    () => {
      if (!!window.location.href.match(/id=.*&state=succeeded/)) {
        toast.success('Thanks for subscribing!')
        posthog.capture('subscribed', me.account.individual_subscription)

        /**
         * Keep it for 500ms for hotjar to capture the URL
         *  so we can filter out recordings with users
         *  who bought a sub
         */
        setTimeout(() => {
          window.history.replaceState &&
            window.history.replaceState(null, null, window.location.pathname)
        }, 500)
      }
    },
    [me.account.individual_subscription]
  )

  /**
   * Removes utm role parameter after 500ms for Facebook Pixel to capture the URL
   */
  useEffect(() => {
    if (!!window.location.href.match(/[?&]utm_role=/)) {
      setTimeout(() => {
        if (window.history.replaceState) {
          window.history.replaceState(null, null, window.location.pathname)
        }
      }, 500)
    }
  }, [])

  useEffect(
    () => {
      setPresentation(null)
      setEmailMeStatus(null)

      if (id) {
        apiClient
          .get(`/v3/presentations/${id}`, {
            params: { include: DEFAULT_INCLUDE }
          })
          .then(res => setPresentation(res.data.presentation))
        if (!todayPresentationId) {
          apiClient
            .get('/v3/p365/today', {
              params: {
                count: 1,
                from: 0
              }
            })
            .then(res => {
              setTodayPresentationId(res.data.presentations[0].id)
            })
        }
      } else {
        apiClient
          .get('/v3/p365/today', {
            params: {
              count: 1,
              from: 0,
              include: DEFAULT_INCLUDE
            }
          })
          .then(res => {
            const presentation = res.data.presentations[0]
            setPresentation(presentation)
            setTodayPresentationId(presentation.id)
          })
      }
    },
    [id] // eslint-disable-line
  )

  useEffect(
    () => {
      if (!presentation) return

      const handleScroll = () => {
        posthog.capture('scrolled on prompt', {
          lesson_category: presentation.category || null,
          lesson_id: presentation.id || null,
          lesson_title: presentation.title || null
        })
        window.removeEventListener('scroll', handleScroll)
      }

      window.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    },
    [presentation]
  )

  useEffect(
    () => {
      const handleScroll = () => {
        if (
          window.innerHeight + window.scrollY >=
          document.documentElement.scrollHeight
        ) {
          if (!restrictedPrompt && presentation) {
            apiClient.post('/v3/me/activated_with_product', {
              type: 'content'
            })
            posthog.capture('activate', { type: 'content' })
            posthog.capture('Scrolled to the bottom of the prompt (v2)', {
              lesson_category: presentation.category || null,
              lesson_id: presentation.id || null,
              lesson_title: presentation.title || null
            })
          }

          window.removeEventListener('scroll', handleScroll)
        }
      }

      window.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    },
    [presentation, restrictedPrompt]
  )

  const [upsellModalOpen, setUpsellModalOpen] = useState(false)
  const [emailMeStatus, setEmailMeStatus] = useState(null)

  const { hadTrialBefore } = useSubscriptionDetails()

  return (
    <PromptsLayout>
      <div className={classes.container}>
        <Nav presentation={presentation} />
        <header className={classes.fixedHeader}>
          {allDataLoaded &&
            !restrictedPrompt && (
              <Actions
                key={selectedPresentation.id}
                presentation={selectedPresentation}
              />
            )}
        </header>
        <HeroHeader>
          {({ scrolledPastHero }) => (
            <div
              className={classes.headerHolder}
              style={!allDataLoaded ? { pointerEvents: 'none' } : null}>
              {allDataLoaded &&
                !restrictedPrompt && (
                  <>
                    {scrolledPastHero && (
                      <>
                        <div className={classes.headerDifficulty}>
                          {difficultySelector}
                        </div>
                        <div className={classes.actionsHolder}>
                          <Actions
                            key={selectedPresentation.id}
                            presentation={selectedPresentation}
                          />
                        </div>
                      </>
                    )}
                  </>
                )}
            </div>
          )}
        </HeroHeader>
        <section className={`h-screen-header ${classes.heroSection}`}>
          {allDataLoaded && (
            <>
              <Image
                onContextMenu={e => {
                  e.preventDefault()
                }}
                className={classes.heroImage}
                src={presentation.image && presentation.image.url}
                alt={selectedPresentation.title}
              />
              <footer
                className={classNames(classes.heroFooter, {
                  [classes.restrictedFooter]: restrictedPrompt
                })}>
                {presentation.category === 'theme_based' &&
                  yearGroup && (
                    <p className={classes.info}>
                      Age {yearGroup.from}-{yearGroup.to}
                    </p>
                  )}

                <h2 className={classes.title}>{selectedPresentation.title}</h2>
                {!!presentation.p365 &&
                  !!selectedPresentation.slides[3] &&
                  !!selectedPresentation.slides[3].text && (
                    <>
                      {presentation.sponsored ? (
                        <p className={classes.snippet}>
                          Today's prompt, with thanks to <br />
                          {presentation.id === '0e5985af' && (
                            <a
                              href="https://www.daisyeducationuk.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => {
                                posthog.capture(
                                  'clicked sponsor logo from prompt',
                                  {
                                    sponsor: 'daisy',
                                    lesson_category: presentation.category,
                                    lesson_id: presentation.id,
                                    lesson_title: presentation.title
                                  }
                                )
                              }}>
                              <img
                                src={daisyLogo}
                                alt="Daisy Education logo"
                                className={classes.sponsoredLogo}
                                width={150}
                                height={25}
                              />
                            </a>
                          )}
                          {presentation.id === '9ea171cb' && (
                            <a
                              href="https://learn.sumdog.com/"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => {
                                posthog.capture(
                                  'clicked sponsor logo from prompt',
                                  {
                                    sponsor: 'sumdog',
                                    lesson_category: presentation.category,
                                    lesson_id: presentation.id,
                                    lesson_title: presentation.title
                                  }
                                )
                              }}>
                              <img
                                src={sumdogLogo}
                                alt="Sumdog logo"
                                className={classes.sponsoredLogo}
                                width={100}
                                height={41}
                              />
                            </a>
                          )}
                        </p>
                      ) : (
                        !restrictedPrompt && (
                          <p className={classes.snippet}>
                            Scroll to writing prompts
                          </p>
                        )
                      )}
                      {!restrictedPrompt && (
                        <ButtonElement
                          onClick={() => {
                            posthog.capture(
                              'click on scroll button on prompt',
                              {
                                lesson_category: presentation.category || null,
                                lesson_id: presentation.id || null,
                                lesson_title: presentation.title || null
                              }
                            )
                            window.scrollTo({
                              top: window.innerHeight - 40,
                              behavior: 'smooth'
                            })
                          }}
                          className={`${
                            classes.scroll
                          } metrics__prompt_scroll_button`}>
                          <SvgScrollArrow />
                        </ButtonElement>
                      )}
                    </>
                  )}
                {!restrictedPrompt && (
                  <SaveForLaterBanner presentation={presentation} />
                )}
                {restrictedPrompt && (
                  <div className={classes.restricted}>
                    <div className={classes.restrictedHolder}>
                      {presentation.p365_day && (
                        <p>
                          Free on{' '}
                          <strong className={classes.restrictedDate}>
                            {date}
                          </strong>
                        </p>
                      )}
                      {emailMeStatus !== 'reminded' && (
                        <Button
                          className={`metrics__prompt_panel--email ${
                            classes.emailMeCTA
                          }`}
                          tall
                          pending={emailMeStatus === 'pending'}
                          simple
                          onClick={() => {
                            posthog.capture(
                              'clicked on remind me via email cta from prompt',
                              {
                                lesson_category: presentation.category,
                                lesson_id: presentation.id,
                                lesson_title: presentation.title
                              }
                            )
                            setEmailMeStatus('pending')
                            apiClient
                              .post(
                                `/v3/presentations/${
                                  presentation.id
                                }/remind_when_free`
                              )
                              .then(res => {
                                setEmailMeStatus('reminded')
                              })
                              .catch(e => {
                                if (getErrorInfo(e).status === 400) {
                                  setEmailMeStatus('reminded')
                                } else {
                                  errorHandler(e)
                                }
                              })
                          }}>
                          Email me when this prompt is free
                        </Button>
                      )}
                      {emailMeStatus === 'reminded' && (
                        <Button
                          icon={<FontAwesomeIcon icon={faCheck} />}
                          className={`metrics__prompt_panel--email ${
                            classes.emailMeCTA
                          }`}
                          tall
                          disabled
                          simple>
                          Done. We'll email you on {date} when this prompt is
                          free.
                        </Button>
                      )}
                      {!studentWithoutSub &&
                        !hadTrialBefore && (
                          <>
                            <span>or</span>
                            <Button
                              className={`metrics__prompt_panel ${
                                classes.ftPromptCTA
                              }`}
                              tall
                              simple
                              onClick={() => {
                                posthog.capture(
                                  'triggers upsell modal from prompt',
                                  {
                                    lesson_category: presentation.category,
                                    lesson_id: presentation.id,
                                    lesson_title: presentation.title
                                  }
                                )
                                setModalOpen(true)
                              }}>
                              Start a free trial to access it now
                            </Button>
                          </>
                        )}
                      <div className={classes.slideDeck}>
                        <SlidesDeck presentation={presentation} />
                        {presentation.p365_day ? (
                          <p className={classes.restrictedActivitiesMessage}>
                            Includes {presentation.slides.length - 4} writing
                            activities
                          </p>
                        ) : (
                          <p style={{ height: 48 }} />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </footer>
            </>
          )}
        </section>
        {restrictedPrompt ? (
          <div className={classes.restrictedPadding} />
        ) : (
          <section className={classes.activities}>
            {presentation && (
              <div ref={slidesContainerRef} className={classes.slidesHolder}>
                <header className={classes.activitiesHeader}>
                  <img
                    src={wiggleBorder}
                    alt="wiggle border"
                    width={530}
                    height={15}
                  />
                  <h3>Writing Activities for "{presentation.title}"</h3>
                  {isDifferentiated && (
                    <div className={classes.mainDiffSelector}>
                      <p>Select difficulty level for writing activities</p>
                      {difficultySelector}
                    </div>
                  )}
                </header>
                <Presentation
                  containerRef={slidesContainerRef}
                  multiSlides
                  data={selectedPresentation}>
                  {({ slides }) => {
                    const sliceFrom =
                      presentation.category === 'quick_writes' ? 2 : 3
                    return slides
                      .slice(sliceFrom, slides.length)
                      .map((slide, i) => {
                        return (
                          <Fragment key={i}>
                            <div className={classes.slide}>
                              <div
                                className={`${
                                  classes.slideHolder
                                } ${!hasAccessToTL &&
                                  (selectedPresentation.slides[i + sliceFrom]
                                    .restricted
                                    ? classes.slideRestricted
                                    : '')}`}>
                                {slide}
                              </div>
                              {!hasAccessToTL &&
                                selectedPresentation.slides[i + sliceFrom]
                                  .restricted && (
                                  <Button
                                    big
                                    wide
                                    icon={<SubsCrown accent />}
                                    onClick={() => {
                                      posthog.capture(
                                        'clicked on slide upsell cta'
                                      )
                                      setUpsellModalOpen(true)
                                    }}
                                    className={classes.slideRestrictedCTA}>
                                    Unlock Pobble Premium
                                  </Button>
                                )}
                            </div>
                          </Fragment>
                        )
                      })
                  }}
                </Presentation>
                <UpsellModal
                  id="slide"
                  isOpen={upsellModalOpen}
                  requestClose={() => setUpsellModalOpen(false)}
                />
                {me.account.role_in_life !== 'student' && (
                  <RateLessonCTA id={selectedPresentation.id} />
                )}
              </div>
            )}
          </section>
        )}
        <EditUpsell
          isOpen={editUpsellOpen}
          requestClose={() => setEditUpsellOpen(false)}
        />
        <UpsellModal
          id="panel"
          isOpen={modalOpen}
          requestClose={() => setModalOpen(false)}
        />
      </div>
    </PromptsLayout>
  )
})
